import { createSlice } from '@reduxjs/toolkit';
import { defaultFeaturedLotsSlice } from '@/redux/modules/featuredLots/featuredLots.types';
import {
    fetchFeaturedLotsByCatalogId,
    fetchSuggestedFeaturedLots,
    saveFeaturedLotsByCatalogId,
} from '@/redux/modules/featuredLots/featuredLots.actions';

const featuredLotsSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(fetchFeaturedLotsByCatalogId.pending, (slice, { meta }) => {
            slice.isLoading = true;
            delete slice.error[meta.arg];
        });
        builder.addCase(fetchFeaturedLotsByCatalogId.fulfilled, (slice, { meta, payload }) => {
            slice.byId[meta.arg] = payload;
            slice.isLoading = false;
        });
        builder.addCase(fetchFeaturedLotsByCatalogId.rejected, (slice, { meta, payload }) => {
            slice.isLoading = false;
            slice.error[meta.arg] = payload.message;
        });

        builder.addCase(saveFeaturedLotsByCatalogId.pending, (slice, { meta }) => {
            slice.isLoading = true;
            delete slice.error[meta.arg.catalogId];
            slice.success = false;
        });
        builder.addCase(saveFeaturedLotsByCatalogId.fulfilled, (slice, { meta, payload }) => {
            slice.byId[meta.arg.catalogId] = {
                ...slice.byId[meta.arg.catalogId],
                featuredLots: payload,
            };
            slice.isLoading = false;
            slice.success = true;
        });
        builder.addCase(saveFeaturedLotsByCatalogId.rejected, (slice, { meta, payload }) => {
            slice.isLoading = false;
            slice.error[meta.arg.catalogId] = payload.message;
        });

        builder.addCase(fetchSuggestedFeaturedLots.fulfilled, (slice, { meta, payload }) => {
            slice.suggestionsById[meta.arg] = payload;
        });
    },
    initialState: defaultFeaturedLotsSlice,
    name: 'featuredLots',
    reducers: {},
});

export const { reducer: featuredLotsReducer } = featuredLotsSlice;
